<template>
  <a-drawer
    width="35%"
    :label-col="4"
    :wrapper-col="14"
    v-model:open="open"
    @close="onClose"
  >
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form ref="formRef" :model="form" :rules="rules">
      <a-form-item label="用户ID,关联{sys_user.id}" name="userId">
        <a-input
          v-model:value="form.userId"
          placeholder="请输入用户ID,关联{sys_user.id}"
        />
      </a-form-item>
      <a-form-item label="操作人ID,关联{sys_user.id}" name="operationId">
        <a-input
          v-model:value="form.operationId"
          placeholder="请输入操作人ID,关联{sys_user.id}"
        />
      </a-form-item>
      <a-form-item label="时间" name="operationTime">
        <a-date-picker
          style="width: 100%"
          v-model:value="form.operationTime"
          format="YYYY-MM-DD HH:mm:ss"
          allow-clear
        />
      </a-form-item>
      <a-form-item label="事由" name="operationReason">
        <a-input
          v-model:value="form.operationReason"
          placeholder="请输入事由"
        />
      </a-form-item>
      <a-form-item label="操作人" name="operationName">
        <a-input
          v-model:value="form.operationName"
          placeholder="请输入操作人"
        />
      </a-form-item>
      <a-form-item label="备注" name="operationRemark">
        <a-input
          v-model:value="form.operationRemark"
          placeholder="请输入备注"
        />
      </a-form-item>
      <a-form-item label="是否显示 1显示 0-不显示" name="status">
      </a-form-item>
      <a-form-item label="排序" name="sort">
        <a-input v-model:value="form.sort" placeholder="请输入排序" />
      </a-form-item>
      <a-form-item label="备注" name="remark">
        <a-input
          v-model:value="form.remark"
          placeholder="请输入内容"
          type="textarea"
          allow-clear
        />
      </a-form-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel"> 取消 </a-button>
        </a-space>
      </div>
    </a-form>
  </a-drawer>
</template>

<script setup>
import { ref, reactive, nextTick } from 'vue'
import { message } from 'ant-design-vue'
import { getUserLog, addUserLog, updateUserLog } from '@/api/system/userLog'

const emit = defineEmits(['ok', 'close'])

const formRef = ref()
const submitLoading = ref(false)
const formTitle = ref('')
const formType = ref(1)
const open = ref(false)

const form = reactive({
  id: null,
  userId: null,
  operationId: null,
  operationTime: null,
  operationReason: null,
  operationName: null,
  operationRemark: null,
  status: 0,
  sort: null,
  createTime: null,
  remark: null,
})

const rules = {
  sort: [{ required: true, message: '排序不能为空', trigger: 'blur' }],
}

function onClose() {
  open.value = false
  // 触发关闭事件，通知父组件刷新表格
  emit('close')
}

function cancel() {
  open.value = false
  reset()
  // 触发关闭事件，通知父组件刷新表格
  emit('close')
}

function reset() {
  formType.value = 1
  Object.assign(form, {
    id: null,
    userId: null,
    operationId: null,
    operationTime: null,
    operationReason: null,
    operationName: null,
    operationRemark: null,
    status: 0,
    sort: null,
    createTime: null,
    remark: null,
  })
  nextTick(() => {
    if (formRef.value) {
      formRef.value.resetFields()
    }
  })
}

function handleAdd(row) {
  reset()
  formType.value = 1
  open.value = true
  formTitle.value = '添加'
}

function handleUpdate(row, ids) {
  reset()
  formType.value = 2
  const id = row ? row.id : ids
  getUserLog({ id: id }).then((response) => {
    Object.assign(form, response.data)
    open.value = true
    formTitle.value = '修改'
  })
}

async function submitForm() {
  try {
    await formRef.value.validate()
    submitLoading.value = true
    if (form.id !== undefined && form.id !== null) {
      await updateUserLog(form)
      message.success('修改成功', 3)
      open.value = false
      emit('ok')
    } else {
      await addUserLog(form)
      message.success('新增成功', 3)
      open.value = false
      emit('ok')
    }
  } catch (error) {
    return false
  } finally {
    submitLoading.value = false
  }
}

defineExpose({
  handleAdd,
  handleUpdate,
})
</script>
